import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function ZeroToLowMerchant({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (isError) setIsError(false);
  };

  const validateForm = () => {
    if (!primaryDetails.merchant_transaction) {
      setIsError(true);
      return false;
    }
    return true;
  };

  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (validateForm()) {
      if (primaryDetails.merchant_transaction === "Yes") {
        navigation.go("zero-to-low-merchant-yes");
      } else {
        navigation.go("visibility-photo");
      }
    } else {
      toast.error("Please select Yes or No.");
    }
  };

  const handleBack = (e) => {
    navigation.previous();
  };

  const options = ["Yes", "No"];

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">ZERO TO LOW MERCHANTS</h4>
              <p className="form-desc">Zero to Low Transaction Merchant</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Zero to Low Transaction Merchant
                      <span className="form-required">*</span>
                    </Form.Label>

                    <div
                      className={`form-radio-group ${
                        isError ? "form-group-error" : ""
                      }`}
                    >
                      {options.map((option) => (
                        <div key={option} className="form-radio-item">
                          <Form.Check
                            type="radio"
                            id={`zero_to_low_${option.toLowerCase()}`}
                            name="merchant_transaction"
                            value={option}
                            checked={
                              primaryDetails.merchant_transaction === option
                            }
                            onChange={handleInputChange}
                            label={option}
                            className="form-radio"
                          />
                        </div>
                      ))}
                    </div>
                    {isError && (
                      <div className="form-error">
                        Please select Yes or No.
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ZeroToLowMerchant;
